/* Adapted from osrs-sdk RangedWeapon / TwistedBow / Weapon (GPL-3.0).
 * Fixed accurate speeds, canonical roll denominators, ammo stacking, player
 * magic defence, and chin distance/secondary hit behaviour. */
import {ITEMS,equipmentBonuses} from '../data/items';
import {prayerByName} from '../data/prayers';
import type {Player,Entity,Style} from './types';
import {distance} from '../vendor/osrs-sdk/Pathing';
export function hitChance(a:number,d:number):number {a=Math.max(0,Math.floor(a));d=Math.max(0,Math.floor(d));return a>d?1-(d+2)/(2*(a+1)):a/(2*(d+1));}
export function weaponSpeed(p:Player){return (ITEMS[p.equipment.weapon?.id??'']?.weapon?.speed??6)-(p.style==='rapid'?1:0);}
export function weaponRange(p:Player){const base=ITEMS[p.equipment.weapon?.id??'']?.weapon?.range??1;return Math.min(10,base+(p.style==='longrange'?2:0));}
export function defenceMultiplier(p:Player){return Math.max(prayerByName(p.offensive)?.defence??1,...p.auxPrayers.map(n=>prayerByName(n)?.defence??1));}
export function rangedRoll(p:Player,target:Entity,special=false){
 const b=equipmentBonuses(p.equipment),prayer=prayerByName(p.offensive),id=p.equipment.weapon?.id;
 const accurate=p.style==='accurate'?3:0;
 const effectiveAccuracy=Math.floor(p.stats.range*(prayer?.accuracy??1))+accurate+8;
 const effectiveStrength=Math.floor(p.stats.range*(prayer?.strength??1))+accurate+8;
 let maxHit=Math.floor(.5+effectiveStrength*((b.other.rangedStrength??0)+64)/640);
 let attackRoll=effectiveAccuracy*((b.attack.range??0)+64);
 if(id==='TwistedBow'){
  const magic=Math.min(target.kind==='jad'?510:150,250);
  const acc=Math.min(1.4,Math.max(0,(140+(3*magic-10)/100-Math.pow(.3*magic-100,2)/100)/100));
  const dmg=Math.min(2.5,Math.max(0,(250+(3*magic-14)/100-Math.pow(.3*magic-140,2)/100)/100));
  attackRoll=Math.floor(attackRoll*acc);maxHit=Math.floor(maxHit*dmg);
 }else if(id==='BowOfFaerdhinen'){
  attackRoll=Math.floor(attackRoll*(1+(b.other.crystalAccuracy??0)));maxHit=Math.floor(maxHit*(1+(b.other.crystalDamage??0)));
 }else if(id==='BlackChinchompa'){
  const dist=distance(p.tile,target),band=dist<=3?0:dist<=6?1:2;
  const table={accurate:[1,.75,.5],rapid:[.75,1,.75],longrange:[.5,.75,1]};attackRoll=Math.floor(attackRoll*table[p.style][band]);
 }
 if(special&&id==='Blowpipe'){attackRoll*=2;maxHit=Math.floor(maxHit*1.5);}
 const defenceRoll=target.kind==='jad'?(480+9)*64:(100+9)*(130+64);
 return {attackRoll,defenceRoll,maxHit,accuracy:hitChance(attackRoll,defenceRoll)};
}
export function incomingRoll(p:Player,style:Style,healer=false){
 const b=equipmentBonuses(p.equipment),dm=defenceMultiplier(p),stance=p.style==='longrange'?3:0;
 const defence=style==='magic'?Math.floor(p.stats.magic*.7+Math.floor(p.stats.defence*dm)*.3)+8:Math.floor(p.stats.defence*dm)+stance+8;
 const bonus=style==='magic'?b.defence.magic:style==='range'?b.defence.range:healer?b.defence.crush:b.defence.stab;
 const defenceRoll=defence*((bonus??0)+64);
 const attackRoll=healer?(165+9)*64:style==='magic'?(510+9)*164:style==='range'?(1020+9)*144:(750+9)*64;
 return {attackRoll,defenceRoll,maxHit:healer?18:113,accuracy:hitChance(attackRoll,defenceRoll)};
}
export function projectileDelay(p:Player,target:Entity){const d=distance(p.tile,target);return p.equipment.weapon?.id==='Blowpipe'||p.equipment.weapon?.id==='BlackChinchompa'?Math.floor(d/6)+1:Math.floor((3+d)/6)+1;}
